module.exports = __webpack_public_path__ + "static/media/advantage3.7db8c0bd.png";